import styled from "@emotion/styled";
import { Maybe } from "aid-form-service/lib/utils/index.types";

export const FieldContainer = styled.div<{ halfWidth: Maybe<boolean> }>`
  width: ${({ halfWidth }) => (halfWidth ? '48%' : '100%')};

  @media only screen and (max-width: 1125px) {
    width: 100%;
  }
`;
